import { SimpleError } from '@common/errors';
import StringDecoder from './StringDecoder.js';
import NumberDecoder from './NumberDecoder.js';
export class EnumDecoder {
    enum;
    constructor(e) {
        this.enum = e;
    }
    decodeField(data, context, currentField) {
        let str;
        try {
            str = StringDecoder.decodeField(data, context, currentField);
            if (Object.values(this.enum).includes(str)) {
                return str;
            }
        }
        catch (e) {
            try {
                str = NumberDecoder.decodeField(data, context, currentField);
                if (Object.values(this.enum).includes(str)) {
                    return str;
                }
            }
            catch (e2) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: 'Expected a number or string for enum: ' + Object.values(this.enum).join(', '),
                    field: currentField,
                });
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: 'Unknown enum value ' + str + ' expected ' + Object.values(this.enum).join(', '),
            field: currentField,
        });
    }
    decode(data) {
        let str;
        try {
            str = data.string;
            if (Object.values(this.enum).includes(str)) {
                return str;
            }
        }
        catch (e) {
            try {
                str = data.number;
                if (Object.values(this.enum).includes(str)) {
                    return str;
                }
            }
            catch (e2) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: 'Expected a number or string for enum: ' + Object.values(this.enum).join(', '),
                    field: data.currentField,
                });
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: 'Unknown enum value ' + str + ' expected ' + Object.values(this.enum).join(', '),
            field: data.currentField,
        });
    }
}
//# sourceMappingURL=EnumDecoder.js.map